'use client';

import { getCookieData, IS_ANDROID, IS_IOS, addQueryParamsUrl } from '@repo/common-utils';

import { useCommonRouter } from '../components/RouterProvider';
import { MAINTENANCE_SETTING_COOKIE } from '../constants';

import { useWorkingPlatform } from './use-working-platform';

export const useExitService = (defaultExitPath: string = '/') => {
  const { workingPlatform, browserType, workingPlatformType } = useWorkingPlatform();
  const router = useCommonRouter();

  const redirectToExitDestination = (path?: string) => {
    const maintenanceSetting = getCookieData(MAINTENANCE_SETTING_COOKIE);
    const pathname = maintenanceSetting?.status ? '/' : path || defaultExitPath;
    router.replace(addQueryParamsUrl(pathname, router.query));
  };

  const exitService = (path?: string) => {
    if (browserType === 'webview') {
      if (workingPlatform === 'kbank') {
        if (IS_IOS) {
          window?.webkit?.messageHandlers?.closeKbankWebView?.postMessage('');
        } else if (IS_ANDROID) {
          window?.kbw?.closeKbankWebView();
        }
      } else if (workingPlatform === 'cashnote') {
        if (IS_IOS) {
          window?.webkit?.messageHandlers.closeModal?.postMessage('{}');
        } else if (IS_ANDROID) {
          window?.CashnoteAndroidInterface?.closeModal?.('{}');
        }
      }
    } else if (workingPlatformType === 'web') {
      if (!window.opener || window.opener === window) {
        redirectToExitDestination(path);
      } else {
        window.close();

        window.setTimeout(() => {
          if (!document.hidden) {
            redirectToExitDestination(path);
          }
        }, 300);
      }
    } else {
      redirectToExitDestination(path);
    }
  };

  return { exitService };
};
